<section class="nutritionalInfo">
	<ul class="nutritionalInfo-list">
		<li class="nutritionalInfo-item" *ngFor="let tag of nutritionalTagsList">
			<a
				cdxButton
				fillStyle="secondaryOutline"
				[inline]="true"
				[chip]="true"
				size="small"
				routerLink="/recipes/search"
				[queryParams]="{ target: tagsSearchTarget, q: tag }"
				(click)="handleTagClick(tag)"
			>
				{{ tag }}
			</a>
		</li>
	</ul>
</section>
